export default __webpack_public_path__ + "static/media/cart_white.751bb788.svg";